var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Listing',{attrs:{"api":"/branchs","title":_vm.title,"fields":_vm.fields,"filters-schema":_vm.filtersSchema,"filters":_vm.filters},on:{"extra-data":_vm.onExtraData}})
}
var staticRenderFns = []

export { render, staticRenderFns }